import m from "../../es2015/themes/microchart";
window.am4themes_microchart = m;


//////////////////
// WEBPACK FOOTER
// ./themes/microchart.js
// module id = null
// module chunks = 